import * as React from "react";
const SvgFiRrCruzeiroSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.91 18.59A9.97 9.97 0 0 1 13.02 24h-1c-.26 0-1.34-.04-1.47-.11-4.82-.71-8.53-4.88-8.53-9.89v-4c0-5.51 4.49-10 10-10h1c3.82 0 7.26 2.13 8.96 5.55a1 1 0 1 1-1.79.89 7.97 7.97 0 0 0-7.17-4.45h-1c-4.41 0-8 3.59-8 8v4c0 3.71 2.54 6.84 5.98 7.74V12c0-.55.45-1 1-1s1 .45 1 1v.53A5.97 5.97 0 0 1 16 11h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-2.21 0-4 1.79-4 4v5h1.02c3.01 0 5.73-1.66 7.11-4.33.25-.49.86-.68 1.35-.43s.68.86.43 1.35"
    />
  </svg>
);
export default SvgFiRrCruzeiroSign;
